import {useContext} from 'react';
import TranslationContext from '../context/translationContext';

export function useTranslation() {

    const translations : { [key:string] : string } = useContext(TranslationContext);

    const translate = (key: string) => {
        let translatedString = translations.hasOwnProperty(key) ? translations[key] : '~' + key;

        return translatedString;
    };

    const keyExists = (key: string) => {
        return translations.hasOwnProperty(key);
    };

    return {translate, keyExists};
}
